
    import * as React from 'react';

    const FavoriteFilled24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M20.543 5.167C19.78 4.127 18.608 3.5 16.998 3.5c-1.611 0-2.983.782-4.115 2.064-.336.381-.63.785-.883 1.19a8.992 8.992 0 00-.884-1.19C9.984 4.282 8.613 3.5 7.002 3.5c-1.61 0-2.78.628-3.545 1.667-.457.62-.679 1.24-.753 1.675-.01.001-.054.157-.096.373-.744 3.816 1.491 8.935 9.09 14.67l.302.228.301-.228c7.6-5.735 9.835-10.854 9.091-14.67a3.49 3.49 0 00-.104-.416c-.081-.433-.303-1.032-.745-1.632z" /></svg>
        </div>
      );
    };

    FavoriteFilled24.displayName = 'FavoriteFilled24';

    export default FavoriteFilled24;
  